// @flow
import { fetchCatalogBidding } from '../api/biddingInfo';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { shouldFetchBiddingInfoForCatalog } from './loaded';

/* Action Types */
export const LOAD_CATALOG_BIDDING_FAIL = 'la/domain/catalogBidding/LOAD_FAIL';
export const LOAD_CATALOG_BIDDING_REQUEST = 'la/domain/catalogBidding/LOAD_REQUEST';
export const LOAD_CATALOG_BIDDING_SUCCESS = 'la/domain/catalogBidding/LOAD_SUCCESS';

/* ACTION CREATORS */
const fetchIfNeeded = async ({ catalogId, dispatch, getState }) => {
    const state = getState();
    if (shouldFetchBiddingInfoForCatalog(state, catalogId)) {
        try {
            const authToken = getAuthToken(state);
            const deployment = getDeployment(state);
            dispatch({
                meta: { actionTime: Date.now() },
                payload: catalogId,
                type: LOAD_CATALOG_BIDDING_REQUEST,
            });
            const response = await fetchCatalogBidding({ authToken, catalogId, deployment });
            dispatch({
                meta: { actionTime: Date.now(), catalogId },
                payload: response.data,
                type: LOAD_CATALOG_BIDDING_SUCCESS,
            });
        } catch (error) {
            dispatch({
                error: true,
                meta: { catalogId },
                payload: error,
                type: LOAD_CATALOG_BIDDING_FAIL,
            });
        }
    }
};

export const fetchCatalogBiddingIfNeeded = (catalogId: number | number[]) => async (
    dispatch: Function,
    getState: Function,
) => {
    return Array.isArray(catalogId)
        ? Promise.all(catalogId.map(id => fetchIfNeeded({ catalogId: id, dispatch, getState })))
        : fetchIfNeeded({ catalogId, dispatch, getState });
};
